module.exports = __webpack_public_path__ + "img/Kontakt Nikolai Gust Grafikdesign Dortmund.1abf360f.svg";